
    
      <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
        <i class="fa-solid fa-arrows-rotate"></i>
      </button>
      <div class="card-content">
        <h3 class="cp-heading">My Open Tickets</h3>
        <section *ngIf="rootScopeService.isDbCaseManagementErrorEnabled" class="error-wrapper">
          <f-alert variant="warning">
            <p *ngIf="rootScopeService.hasNoDbCaseManagementData">
              No Case Management tool available for the selected client.
            </p>
            <p *ngIf="!rootScopeService.hasNoDbCaseManagementData">
              We can’t connect to Case Management right now, please try again
              later. If the error continues, contact myIT.
            </p>
          </f-alert>
        </section>
        <div class="content">
          <p class="content-text" *ngIf="!rootScopeService.isDbCaseManagementErrorEnabled">
            You may have new tasks to complete. Click below to get started.
          </p>
          <ul class="no-margin">
            <li *ngFor="let caseManagement of rootScopeService.dashboardMyTodoData">
              <f-button [iconConfig]="iconConfig" class="ih-view-btn" text="Go to {{ caseManagement.heading }}"
                buttonTitle="Go to {{ caseManagement.heading }}" type="button" variant="action"
                (click)="goToCaseManagement(caseManagement)">
              </f-button>

            </li>
          </ul>
        </div>
      </div>

      <app-loader *ngIf="rootScopeService.dbCaseManagementLoader" [loaderType]="loaderType"
        [loaderMsg]="rootScopeService.showDbMyTodoLoaderMsg"></app-loader>
    
  
